import { S as Swiper } from './swiper-core-BHOuL--z.js';
import { N as Navigation } from './navigation-BkM3VwNI.js';
import './utils-DWOYB00a.js';

class FeaturedCollections extends HTMLElement {
  connectedCallback() {
    const section = this.closest('[id^="shopify-section-"]');
    const prevEl = section.querySelector('[data-swiper-prev]');
    const nextEl = section.querySelector('[data-swiper-next]');

    this.swiper = new Swiper(this, {
      modules: [Navigation],
      slidesPerView: 2,
      spaceBetween: 4,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled bg-info-100 pointer-events-none',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 8,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}

customElements.define('featured-collections', FeaturedCollections);
